import styled from 'styled-components';
import { H1 } from '../../style/typography';
import { min } from '../../lib/responsive';
import { colors } from '../../style/colors';
import { HorizontalRedLines } from '../../lib/shared';

const ScheduleHeader = styled(H1)`
  margin: 0;
  color: ${props => (props.isInPerson ? colors.BLACK : colors.WHITE)};
  line-height: 0.9em;
  transform: rotate(-3.38deg);
  font-size: clamp(2em, 12.25vw, 6em);
  @media ${min.tablet} {
    font-size: clamp(4em, 12vw, 11em);
  }
`;

const ScheduleHeaderContainer = styled.div`
  padding-top: 12rem;
  padding-bottom: 7rem;
  padding-left: 3rem;
  @media ${min.tabletSm} {
    padding-left: 5.8rem;
    padding-bottom: 10rem;
  }
  @media ${min.tablet} {
    padding-left: 8rem;
    padding-bottom: 15rem;
  }
  @media ${min.tabletLg} {
    padding-bottom: 20rem;
    padding-left: 12rem;
  }
  @media ${min.desktop} {
    padding-left: 15rem;
  }
  @media ${min.desktopLg} {
    padding-left: 16rem;
  }
`;

const MicImage = styled.img`
  width: 28%;
  max-width: 30rem;
  position: absolute;
  left: 0;
  z-index: 3;
  top: 11rem;
  @media ${min.mobile} {
    left: -1rem;
  }
  @media ${min.tablet} {
    top: 12rem;
  }
`;

const Star = styled.img`
  position: absolute;
  width: 20%;
  top: 14rem;
  right: 1rem;
  max-width: 30rem;
  @media ${min.mobile} {
    top: 15rem;
    right: 2rem;
  }
  @media ${min.tabletSm} {
    top: 17rem;
  }
  @media ${min.tablet} {
    width: 25%;
    top: 18rem;
  }
  @media ${min.tabletLg} {
    top: 20rem;
  }
  @media ${min.desktop} {
    top: 23.5rem;
    right: 3rem;
  }
  @media ${min.desktopLg} {
    right: 6%;
  }
`;

const ScheduleHorizontalRedLines = styled(HorizontalRedLines)`
  top: 13rem;
  z-index: 0;
  @media ${min.tablet} {
    top: 15rem;
  }
  @media ${min.desktop} {
    top: 18.3rem;
  }
  @media ${min.desktopXlg} {
    display: none;
  }
`;

const ScheduleHorizontalRedLinesXl = styled(HorizontalRedLines)`
  display: none;
  z-index: 0;
  @media ${min.desktopXlg} {
    display: block;
    top: 5rem;
  }
`;

export {
  ScheduleHorizontalRedLines,
  ScheduleHorizontalRedLinesXl,
  MicImage,
  ScheduleHeaderContainer,
  ScheduleHeader,
  Star,
};
